(function () {
  var BREAKPOINT = 1200;
  var swiperInst = null;
  var config = {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    centeredSlides: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    navigation: {
      nextEl: '#usp-bar-next',
      prevEl: '#usp-bar-prev',
    },
  };

  function initUspSwiper() {
    if (window.innerWidth < BREAKPOINT) {
      if (!swiperInst) {
        swiperInst = new Swiper('#usp-bar-swiper', config);
      }
    } else {
      if (swiperInst) {
        swiperInst.destroy(true, true);
        swiperInst = null;
      }
    }
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initUspSwiper, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUspSwiper);
  } else {
    initUspSwiper();
  }

  window.addEventListener('resize', onResize);
}());
